const checkUrlIsValid = (url) => {
  return /^http(s)?:\/\/[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/i.test(url)
}

export default checkUrlIsValid
